export default {"src":"/_next/static/media/GFL.211db5ed.svg","height":18,"width":18};